import { Component, OnDestroy, OnInit } from '@angular/core'
import { NavService } from '../../../services/nav.service'
import { BehaviorSubject, Subject } from 'rxjs'
import { flatMap, takeUntil } from 'rxjs/operators'
import { AppRoutingConfig } from '../../../configuration/app.routing.config'
import { KeySystemNavConfig } from '../../../configuration/key.system.nav.config'
import {
  CylinderPinningsDisplayColumns,
  DeletedKeysDisplayColumns,
  NotesAndKeysDisplayColumns,
  OverridesDisplayColumns,
} from '../../../constants/keying.constants'
import { KeySystem, Structure } from '../../../models/dev.test.models'
import { ErrorService } from '../../../services/error.service'
import { KeyingStructureService } from '../../../services/keying.structure.service'
import { KeyingSystemService } from '../../../services/keying.system.service'

@Component({
    selector: 'app-history-structure.page',
    templateUrl: './history.structure.page.component.html',
    styleUrls: ['./history.structure.page.component.scss'],
    standalone: false
})
export class HistoryStructurePageComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  structure: Structure
  filteredReport = new BehaviorSubject<Array<any>>([])
  reportDisplayColumns

  notesAndKeysDisplayColumns = NotesAndKeysDisplayColumns
  cylinderPinningsDisplayColumns = CylinderPinningsDisplayColumns
  deletedKeysDisplayColumns = DeletedKeysDisplayColumns
  overridesDisplayColumns = OverridesDisplayColumns

  // Temp
  keysAndNotes = [
    {
      user: 'Michael McGinnis',
      date: new Date(),
      description: 'This is the des',
    },
    {
      user: 'Michael McGinnis',
      date: new Date(),
      description: 'This is the des',
    },
    {
      user: 'Michael McGinnis',
      date: new Date(),
      description: 'This is the des',
    },
  ]

  cylinderPinnings = [{ jobName: 'cylinderPinnings' }]

  deletedKeys = [{ jobName: 'deletedKeys' }]

  overrides = [{ jobName: 'overrides' }]

  public readonly tabs = [
    { name: 'Keys & Notes', displayColumns: this.notesAndKeysDisplayColumns, data: this.keysAndNotes, id: 0 },
    {
      name: 'Cylinder Pinnings',
      displayColumns: this.cylinderPinningsDisplayColumns,
      data: this.cylinderPinnings,
      id: 1,
    },
    { name: 'Deleted Keys', displayColumns: this.deletedKeysDisplayColumns, data: this.deletedKeys, id: 2 },
    { name: 'Overrides', displayColumns: this.overridesDisplayColumns, data: this.overrides, id: 3 },
  ]
  public selectedTab = this.tabs[0]
  public selectedTabIndex = 0

  constructor(
    private keyingSystemService: KeyingSystemService,
    private keyingStructureService: KeyingStructureService,
    private errorService: ErrorService,
    private keySystemNavConfig: KeySystemNavConfig,
    private navService: NavService
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.keyingStructureService.structure$.pipe(takeUntil(this.destroy$)).subscribe(
      (structure: Structure) => {
        this.structure = structure

        if (this.structure) {
          let navButtons = [
            {
              name: 'Dashboard',
              active: false,
              icon: 'layout',
              router: AppRoutingConfig.getGenericStructureUrl('structureNewKeySystems', this.structure.id),
            },
            {
              name: 'History',
              active: true,
              icon: 'audit',
              router: AppRoutingConfig.getGenericStructureUrl('structureHistory', this.structure.id),
            },
          ]
          this.navService.setEntities(navButtons)
        }
      },
      (error) => {
        this.errorService.throw(error)
      }
    )

    this.filteredReport.next(this.selectedTab.data)
    this.reportDisplayColumns = this.selectedTab.displayColumns
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  onChangeTab(tab) {
    this.selectedTabIndex = tab.index
    this.selectedTab = this.tabs[tab.index]
    this.filteredReport.next(this.selectedTab.data)
    this.reportDisplayColumns = this.selectedTab.displayColumns
  }
}
